import { FormHelperText, Grid, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import InputField from '../../../../FormControl/input/InputField'
import { useSelector } from 'react-redux'
import Skeleton from '@mui/material/Skeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FormCurriculum from './FormCurriculum'

const Form = ({ onChangeAlert, isPreview, isLoading, type = 'create' }) => {
  const formData = useSelector((state) => state?.subject?.form || {})
  const errorData = useSelector((state) => state?.subject?.error || {})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  )
  const permission = useSelector((state) => state?.session?.permissions?.subject || {})

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert(name, value)
  }

  useEffect(() => {
    const newForm = { ...formData }
    if (['unassigned', 'assigned', 'all'].includes(newForm?.curriculumId)) {
      newForm.curriculumId = ''
    }
    setInputForm(newForm)
  }, [formData])

  useEffect(() => {
    setInputErrors(errorData)
  }, [errorData])

  return (
    <Grid container spacing={2}>
      <Grid item md={2} sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          <Tooltip arrow title='This name will be used to import data from other sources'>
            <FontAwesomeIcon icon={['fal', 'question-circle']} className='text-primary px-1' />
          </Tooltip>
          Subject Course
        </Typography>
      </Grid>
      <Grid item md={9} sm={8}>
        {isPreview ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? <Skeleton /> : form.code}
          </Typography>
        ) : type === 'update' && !permission?.updated?.includes('basic-information') ? (
          <>
            <Typography variant='inherit' component='p'>
              {isLoading ? <Skeleton /> : form.code}
            </Typography>
            {errors.code && <FormHelperText error={true}>{errors.code}</FormHelperText>}
          </>
        ) : (
          <InputField
            id='code'
            name='code'
            error={errors.code}
            helperText={errors.code}
            value={form.code}
            onChange={(e) => onChange(e.target.name, e.target.value)}
          />
        )}
      </Grid>
      <Grid item md={2} sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          Subject Name
        </Typography>
      </Grid>
      <Grid item md={9} sm={8}>
        {isPreview ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? <Skeleton /> : form.name}
          </Typography>
        ) : type === 'update' && !permission?.updated?.includes('basic-information') ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? <Skeleton /> : form.name}
          </Typography>
        ) : (
          <InputField
            id='name'
            name='name'
            error={errors.name}
            helperText={errors.name}
            value={form.name}
            onChange={(e) => onChange(e.target.name, e.target.value)}
          />
        )}
      </Grid>

      <Grid item md={2} sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          description
        </Typography>
      </Grid>
      <Grid item md={9} sm={8}>
        {isPreview ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? <Skeleton /> : form.description}
          </Typography>
        ) : type === 'update' && !permission?.updated?.includes('basic-information') ? (
          <Typography variant='inherit' component='p'>
            {isLoading ? <Skeleton /> : form.description}
          </Typography>
        ) : (
          <InputField
            id='description'
            name='description'
            error={errors.description}
            helperText={errors.description}
            value={form.description}
            multiline={true}
            onChange={(e) => onChange(e.target.name, e.target.value)}
          />
        )}
      </Grid>
      {existLinceseAssessment && (
        <FormCurriculum
          onChangeAlert={onChangeAlert}
          onChange={onChange}
          isPreview={isPreview}
          isLoading={isLoading}
          errors={errors}
          formData={formData}
          form={form}
        />
      )}
    </Grid>
  )
}

export default Form
